import React from 'react'
// import wallpaper from '../imagines/wallpaper1.jpg'
import wallpaper from '../inails&spa-photo/output1.webp'
import wallpaper2 from '../inails&spa-photo/output2.webp'
import wallpaper3 from '../inails&spa-photo/output3.webp'
import img1 from '../imagines/img1.webp';
import img2 from '../imagines/img2.webp';
import img3 from '../imagines/img3.webp';
import img4 from '../imagines/img4.webp';
import img5 from '../imagines/img5.webp';
import img6 from '../imagines/img6.webp';
import img7 from '../imagines/img7.webp';
import img8 from '../imagines/img8.webp';
import img9 from '../imagines/img9.webp';
import img10 from '../imagines/img10.webp';
import img11 from '../imagines/img11.webp';
import img12 from '../imagines/img12.webp';
import img13 from '../imagines/img13.webp';
import img14 from '../imagines/img14.webp';
import img15 from '../imagines/img15.webp';
import img16 from '../imagines/img16.webp';
import img17 from '../imagines/img17.webp';
import img18 from '../imagines/img18.webp';
import img19 from '../imagines/img19.webp';
import img20 from '../imagines/img20.webp';
import img21 from '../imagines/img21.webp';
import img22 from '../imagines/img22.webp';
import img23 from '../imagines/img23.webp';
import img24 from '../imagines/img24.webp';
import img25 from '../imagines/img25.webp';
import img26 from '../imagines/img26.webp';
import img27 from '../imagines/img27.webp';
import img28 from '../imagines/img28.webp';
import img29 from '../imagines/img29.webp';
import img31 from '../imagines/img31.webp';
import img32 from '../imagines/img32.webp';
import img33 from '../imagines/img33.webp';
import img34 from '../imagines/img34.webp';
import img35 from '../imagines/img35.webp';
import img36 from '../imagines/img36.webp';
import img37 from '../imagines/img37.webp';
import img38 from '../imagines/img38.webp';
import img39 from '../imagines/img39.webp';
import img40 from '../imagines/img40.webp';
import img41 from '../imagines/img41.webp';
import img42 from '../imagines/img42.webp';
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../App.js';
import ReviewCard from './reviewcard.js'
const images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42
];
const wallpaperList = [wallpaper, wallpaper2, wallpaper3]
const Body = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'ease-in-out'
  };
  const gallerySettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'ease-in-out',
    arrows: true,
    responsive: [
      {
        breakpoint: 480,
        settings:{
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      }
    ]
  }

  const Reviews = [
    {
      name: 'Danii V.',
      text: 'Parking is a bit limited depending on the time you come most of the spots in the front say "20 minute minute" Which isn\'t realistic if you\'re getting your nails done Nice holiday music was playing & the customer service was good I was greeted almost immediately when I entered the salon They have a variety of different mani and pedicures you can enjoy The most affordable seems to be $28 I wanted french tips with a dash of red for the holidays and my nail tech suggested we do candy cane vibes I\'m happy with the way it turned out I wish I would\'ve asked for more than one nail design but I\'m overall happy They charge an extra $7+ designs including French manicures but I love that they have their prices on their website I did notice their "dip nails" are basically acrylic They\'re not as thin and dipped as the usual They literally mix the power with the gel like substance and place it on your nails like a typical full set and call it dipped but regardless I was content with the service and happy with my cute nails',
      rating: 5
    },
    {
      name: 'Shell M.',
      text: 'Yvonne always does five stars job. She has done my nails since 1992. And she does my daughter\'s nails.',
      rating: 5
    },
    {
      name: 'Hope C.',
      text: 'Stiletto Set by Kim = ‍I\'ve been going to her for years! She never disappoints, always takes her time and every set I\'ve gotten by her has attracted so many compliments. I\'ve never found anyone better!',
      rating: 5
    },
    {
      name: 'Cyn C.',
      text: '"I live 40 minutes north and drove here specifically based on a great visit I had in the past. Was really glad with the attention to detail and happiness at this location. I hate going to nail shops in general, especially when I am afraid the nail techs are going to be mad or grumpy or cut me with their tools. This did not happen here! Jessica took great care with my nails and was very sweet with her service. I\'m thankful for her. She seems to like what she does and it\'s very important to me to spend my money at shops that give this kind of quality service!! Tip them well! Thank you for the help in my self care :)',
      rating: 5
    },
    {
      name: 'Reese S.',
      text: 'My favorite place to get my nails done! From the moment you walk in, the ladies greet you with a friendly smile. Service has always been consistent. I\'ve had my nails and pedi done by multiple ladies and they all have done a great job. I like that they don\'t push to upsell you on a service like many other nail places. You tell them what you want and they go with it. Meg did my nails today and she did an amazing job. Tee has done my nails before and she\'s really good too!',
      rating: 5
    },
    {
      name: 'Ana G.',
      text: 'Went in for a full set. Showed May the nails I wanted and she absolutely crushed it! Love the outcome!',
      rating: 5
    },
    {
      name: 'Andrea L.',
      text: 'I\'ve been coming here for 4 or 5 years now and a review is waaaay overdue. I have never had a bad experience, wait times are always reasonable, service is always great and the nails ALWAYS look on point. Sharing a picture of my last full set with gel and nail design by Tee. Definitely recommend',
      rating: 5
    },
    {
      name: 'Rose A.',
      text: 'Checked in, no wait time. Clean and not crowded for a Thursday morning. The equipment and spa look clean as well. Many selections for regular polish, gel polish and the new Dipping powder! The 2 ladies that worked on me were very gentle and meticulous. They were careful not to knick or over file...thank you lord! They took their time with the layers and UV, and massage. I tried European Spa Ped and Regular Gel Manicure! Colors 040 Sandy Wood for a Fall color feel! I loved how they turned out!',
      rating: 5
    }
  ]
  
  const Reviews2 = [
    {
      name: 'Diane Nicole C.',
      text: 'My best friend and I were looking for a place to get our nails & and toes done for my wedding! We were so welcomed as soon as we stepped in! Sometimes at nail salons we don\'t get that type of greeting. We were seated right away and the ladies were on it!. I never got a pedicure before and Ivy did a fabulous job! She made me feel relaxed and also made my toes super clean and beautiful! Jenny spent so much time on my nails. She wasn\'t rushed and she got exactly what I wanted but better!! She notice how dry my hands were due to the cold weather and did everything to make me feel relaxed and feel beautiful for my big day! Definitely recommend coming here, all the staff are welcoming! Thank you Ivy , Jenny, & Tammy for being so welcoming!',
      rating: 5
    },
    {
      name: 'Anne G.',
      text: 'Both Tammy and Girl did amazing job on doing my mani and pedicure my best friend and I did last minute walk in and welcome us both and showed their hospitality with free drinks and Vietnamese coffee. Thanks Mommy Tammy',
      rating: 5
    },
    {
      name: 'Caro C.',
      text: 'My favorite spot to get my nails done! Lisa did my nails so beautifully and fast, very clean work! 5/5',
      rating: 5
    },
    {
      name: 'Marina S',
      text: 'My daughter and I love this place, the girls are very friendly.This time I asked for a manicure and gel polish only and my daughter got a full set and pedicure.',
      rating: 5
    },
    {
      name: 'Elize A.',
      text: 'tammy is the best! such a clean and thorough job on my gel manicure. I will be back to tammy!',
      rating: 5
    },
    {
      name: 'Jamie L.',
      text: 'Everyone is very nice here and great at what they do. I always request Amy and she does such an amazing job.I usually get dip nails and Amy knows I like more natural colors. I highly recommend seeing any of the ladies here especially Amy!',
      rating: 5
    },
    {
      name: 'Denise V.',
      text: 'The place is very clean and relaxing, I try to come in every couple weeks to get my pedicure and Tammy is my go to tech. I followed her from another location and I\'ll explain why. I always get these painful ingrown toenails, Yes, I\'ve had surgery but they still grow back. Tammy has been so amazing with getting my ingrowns out without causing some crazy pain. I\'m also very happy with the fact that even though they grow back she is very careful when removing them and does not leave small nails that later dig into my skin. I appreciate her patience and kindness when it comes to her services provided. I highly recommend her if your someone like me that has an ingrown toenail issue.',
      rating: 5
    }
  ]
  return (
    <>
      <div className="body">
        <div className="body-content">
          <Slider {...settings} className="body-wallpaper custom-dots">
            {wallpaperList.map((image, index) => (
              <div key={index} className="body-wallpaper-item">
                <picture>
                  <source srcSet={`${image}?w=480`} media="(max-width: 480px)" />
                  <source srcSet={`${image}?w=768`} media="(max-width: 768px)" />
                  <source srcSet={`${image}?w=1200`} media="(max-width: 1200px)" />
                  <img 
                    src={image} 
                    alt={`Wallpaper ${index + 1}`} 
                    loading={index === 0 ? 'eager' : 'lazy'}
                    fetchPriority={index === 0 ? 'high' : 'auto'}
                    decoding= {index === 0 ? 'sync' : 'async'}
                    width="100%"
                    height="600px"
                    className="body-wallpaper-image"
                  />
                </picture>
              </div>
            ))}
          </Slider>
          <div className='body-welcome'>
            <span className='body-welcome-text-1'>LOVE YOURSELF</span>
            <span className='body-welcome-text'>Nails the look</span> 
            <span className='body-welcome-text'>own the style.</span> 
            <a href='/contactUs' className='contact-us'>Contact Us</a>
          </div>
        </div>
        <div className='body-content-2'>
          <div className='body-content-2-box1'>
            <span className='body-content-title'> Gift a Touch of Beauty</span>   
            <span className='body-content-paragraph'>Show your love with the perfect surprise.</span>  
            <a href='/contactUs' className='body-content-2-btn'>Contact Us &#8594;</a>     
          </div>
          <div className='body-content-2-box2'>
            <span className='body-content-title'>Nail Art That Speaks</span> 
            <span className='body-content-paragraph'>Where creativity meets your fingertips.</span>  
            <a href='/gallery' className='body-content-2-btn'>Gallery &#8594;</a>     
          </div>
          <div className='body-content-2-box3'>
            <span className='body-content-title'>Plan Your Next Visit</span> 
            <span className='body-content-paragraph'>Nails, Toes, Brows & Lashes</span>
            <a href='/services' className='body-content-2-btn'>Our Menu &#8594;</a>      
          </div>
        </div>
        <div className='body-content-3'>
          <span className='body-content-title'>Follow Our Journey</span>
          <Slider {...gallerySettings} className="body-gallery custom-dots">
          {images.map((image, index) => (
            <div key={index} className="body-follow-gallery-item">
              <picture>
                <source srcSet={`${image}?w=480`} media="(max-width: 480px)" />
                <source srcSet={`${image}?w=768`} media="(max-width: 768px)" />
                <source srcSet={`${image}?w=1200`} media="(max-width: 1200px)" />
                <img src={image} alt={`gallery-${index}`} loading={index < 4 ? 'eager' : 'lazy'} fetchPriority={index < 4 ? 'high' : 'auto'} decoding={index < 4 ? "sync" : "async"} />
              </picture>
            </div>
          ))}
        </Slider>
        </div>
        <div className='body-content-4'>
          <div className='body-content-4-box1'>
            <span className='body-content-title customer-title'>Our Happy Customers</span>
          </div>
          <div className='body-content-4-box2'>
            <div className='body-content-4-box2-left'>
              <div className="review-marquee">
                <div className="review-marquee-inner">
                  {Reviews.map((review, i) => (
                    <ReviewCard
                      key={i}
                      name={review.name}
                      text={review.text}
                      rating={review.rating}
                    />
                  ))}
                  {Reviews.map((review, i) => (
                    <ReviewCard
                      key={`repeat-${i}`}
                      name={review.name}
                      text={review.text}
                      rating={review.rating}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className='body-content-4-box2-right'>
            <div className="review-marquee">
                <div className="review-marquee-inner-2">
                  {Reviews2.map((review, i) => (
                    <ReviewCard
                      key={i}
                      name={review.name}
                      text={review.text}
                      rating={review.rating}
                    />
                  ))}
                  {Reviews2.map((review, i) => (
                    <ReviewCard
                      key={`repeat-${i}`}
                      name={review.name}
                      text={review.text}
                      rating={review.rating}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Body